export interface Logger {
  info(msg: string, context?: any): void

  debug(msg: string, context?: any): void

  error(msg: string, context?: any): void
}

class LoggerInstance implements Logger {
  debug(msg: string, context?: any): void {
    if (!context) {
      return console.debug(msg)
    }

    console.debug(msg, context)
  }

  error(msg: string, context?: any): void {
    if (!context) {
      return console.error(msg)
    }

    console.error(msg, context)
  }

  info(msg: string, context?: any): void {
    if (!context) {
      return console.info(msg)
    }

    return console.info(msg, context)
  }
}

export default new LoggerInstance()
